module.exports = __webpack_public_path__ + "img/040-axe.aeb030f8.png";